import { QueryClient } from '@tanstack/react-query';
import { useNonF2fMedicalCategoriesQuery } from './medicalCategory.gql.impl';

const DEFAULT_SIZE = 9;
const useNonF2fMedicalCategories = (size = DEFAULT_SIZE) => {
  const { data, isLoading, error } = useNonF2fMedicalCategoriesQuery({ size });

  const medicalCategories = data?.nonF2fMedicalCategories ?? [];

  return {
    medicalCategories,
    isLoading,
    error,
  };
};

export default useNonF2fMedicalCategories;

useNonF2fMedicalCategories.prefetchQuery = async (queryClient: QueryClient, size = DEFAULT_SIZE) => {
  await queryClient.prefetchQuery(
    useNonF2fMedicalCategoriesQuery.getKey({ size }),
    useNonF2fMedicalCategoriesQuery.fetcher({ size })
  );
};
